import {gql} from '@apollo/client';

const IMPORT_PRODUCTION_COST_PLANR_DATA = gql`
  mutation importProductionCostPlanrData($id: ID!, $scheduleIds: [ID!]!) {
    importProductionCostPlanrData(
      productionCostEntryId: $id
      scheduleIds: $scheduleIds
    ) {
      driverShiftsCalculationTypeAllowed
      kpis {
        avgWeeklyDistancePerBus {
          value
        }
        avgWeeklyOpDays {
          value
        }
        totalDistance {
          value
        }
        totalScheduleHours {
          value
        }
      }
      busProvidedValues {
        id
        busPartnerBusTypeCostEntryId
        busPartnerId
        countryBusTypeCostEntryId
        countryRulesCountryId
        vehicleId
        vehicleName
      }
      busScheduleProvidedValues {
        description
        endDate
        lineNumber
        name
        scheduleId
        size
        startDate
        busScheduleProvidedValuesEntries {
          accommodationCostPerNight
          accommodationsPerWeek
          additionalCostPerTrip
          busUtilizationFactor
          countryDriverConceptTypeId
          currency
          driverSalary
          emptyHrPerDay
          emptyKmPerDay
          flixStandardCostOverwrite
          id
          numberOfDrivers
          numberOfCrewMembers
          crewMemberSalary
          replacementHrPerDay
          replacementKmPerDay
          salaryChange
          totalDriverCostOverwrite
          vehicleId
          dailyAllowance
          kpis {
            avgDriverFactor {
              value
            }
            avgWeeklyDistance {
              value
            }
            avgWeeklyOpDays {
              value
            }
            avgWeeklyScheduleHours {
              value
            }
            avgWeeklyWorkingHours {
              value
            }
            totalDistance {
              value
            }
            totalScheduleHours {
              value
            }
          }
        }
      }
    }
  }
`;

export default IMPORT_PRODUCTION_COST_PLANR_DATA;
